import { TranslationObject } from '@ngx-translate/core';
import { Topic } from '@lib.core/entities/topic/topic';
import { Industry } from '@lib.core/entities/industry/industry';
import { Location } from '@lib.core/entities/location/location';
import { KPI } from '@lib.core/entities/indicator/kpi';

export class ProfileOverview {
  profileHashKey: string;
  nameId: string;
  title: TranslationObject;
  description: TranslationObject;
  date: Date;
  kpis?: KPI[];
  topics: Topic[];
  isSubscribed: boolean;
  imageUrl: string;
  subtitle?: TranslationObject;
  industries?: Industry[];
  location?: Location;
  generatedId: string;

  constructor(
    profileHashKey: string,
    nameId: string,
    title: TranslationObject,
    description: TranslationObject,
    date: Date,
    kpis: KPI[] | undefined,
    topics: Topic[],
    isSubscribed: boolean,
    imageUrl: string,
    subtitle?: TranslationObject,
    industries?: Industry[],
    location?: Location
  ) {
    this.profileHashKey = profileHashKey;
    this.nameId = nameId;
    this.title = title;
    this.description = description;
    this.date = date;
    this.kpis = kpis;
    this.topics = topics;
    this.isSubscribed = isSubscribed;
    this.imageUrl = imageUrl;
    this.subtitle = subtitle;
    this.industries = industries;
    this.location = location;
    this.generatedId = `${Date.now()}-${Math.random()}`;
  }

  getImageUrl(blobStorageAccountUri: string) {
    const imageFileNames = [
      'community-profile',
      'economic-profile',
      'demographics-profile',
      'workforce-profile',
      'mobility-commuting-profile',
      'quality-of-life-profile',
      'housing-profile',
      'sector-profile',
      'industry-profile',
    ];

    const imageFileName = imageFileNames.find((name) =>
      this.nameId.includes(name)
    );
    return `${blobStorageAccountUri}/public/shared/profiles/${imageFileName}.svg`;
  }
}
